import axios from "axios";

// const API_ROOT = "https://docker.estoffice.org/api"
const API_ROOT = "https://test3.estoffice.com/api"
// const API_ROOT = "/api"

export const ApiCall = {

  get: <T>(url: string, query: any = {}): Promise<T> => {
    return new Promise<T>((resolve, reject) => {
      axios.get(API_ROOT + url, {params: query})
        .then(res => {
          resolve(res.data.data)
        })
        .catch(e => reject(e))
    })
  }

}